var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0533 22.6667H4.72C4.53794 22.6672 4.36244 22.5987 4.22885 22.475C4.09526 22.3513 4.01349 22.1816 4 22V8.00003C4 7.80907 4.07586 7.62594 4.21088 7.49091C4.34591 7.35589 4.52904 7.28003 4.72 7.28003H14.0533C14.2443 7.28003 14.4274 7.35589 14.5625 7.49091C14.6975 7.62594 14.7733 7.80907 14.7733 8.00003V22C14.7598 22.1816 14.6781 22.3513 14.5445 22.475C14.4109 22.5987 14.2354 22.6672 14.0533 22.6667ZM5.44 21.2534H13.3333V8.6667H5.44V21.2534Z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71997 9.97339H12.0533V11.3067H6.71997V9.97339Z",
    fill: "#192048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 18.5401H16.0666V6.00008H8.06665V4.66675H16.7333C16.9101 4.66675 17.0797 4.73699 17.2047 4.86201C17.3297 4.98703 17.4 5.1566 17.4 5.33341V18.5401Z",
    fill: "#192048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0534 15.3333H18.7201V3.33333H11.3867V2H19.3867C19.5635 2 19.7331 2.07024 19.8581 2.19526C19.9831 2.32029 20.0534 2.48986 20.0534 2.66667V15.3333Z",
    fill: "#192048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71997 18.5867H10.0533V20.0267H8.71997V18.5867Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetData);
export default __webpack_public_path__ + "static/media/AssetData.4159badd9150faae4212efa4fa84983e.svg";
export { ForwardRef as ReactComponent };